import React, { useState, useEffect } from 'react'
import Loader from '../../../../presentationals/Loader/Loader.component';
import { APIS } from '../api-factory';
import NodataImage from '../../../../../images/nodata.png';
import Pagination from '@mui/material/Pagination';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { POST_HEADER } from '../../../../../utils/apiHeaders';

const size = 10;
export default function List({ handleEdit }) {
    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPage, setCurrentPage] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" })

    useEffect(() => {
        getApi(currentPage)
    }, [])

    const getApi = (val) => {
        setLoader(true)
        fetch(APIS.GET_BANNERS_BY_PAGE_NUMBER + val + "&size=" + size)
            .then((res) => res.json())
            .then((callback) => {
                console.log("call", callback)
                setTableData(callback?.data?.banners)
                setTotalPage(callback?.data?.totalPages)
            })
            .finally(
                setLoader(false)
            )
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value)
        getApi(value - 1)
    }

    const handleDelete = (val) => {
        setLoader(true)
        fetch(APIS.DELETE_BANNER_BY_ID + val, {
            method: 'DELETE',
            headers: POST_HEADER
        })
            .then((res) => res.json())
            .then((callback) => {
                setShowPopup({ show: true, popupStatus: 'Data Deleted successfully' })
            })
            .catch(err => {
                setShowPopup({ show: true, popupStatus: 'Error Deleting Data' })
            })
            .finally(() => {
                setLoader(false)
                removePopup()
                setCurrentPage(0)
                getApi(0)
            })

    }

    const closePopup = () => {
        setShowPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            {
                showPopup?.show ?
                    <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                    : ''}

            <div className="container-fluid" style={{ marginTop: '50px' }}>
                <div className="col-xs-12" style={{ marginTop: '30px' }}>
                    <div className='table-responsive full-height'>
                        {tableData?.length > 0 ?
                            <>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className='table credhub-table'>
                                        <thead>
                                            <tr>
                                                <th scope="col">Title</th>
                                                <th scope='col'>Description</th>
                                                <th scope="col">Image URL</th>
                                                <th scope="col">Priority</th>
                                                <th scope="col">Start Date</th>
                                                <th scope="col">End Date</th>
                                                <th scope="col">Is Active</th>
                                                <th scope="col">Created At</th>
                                                <th scope="col">Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableData?.map((row, i) => {
                                                return (
                                                    <tr key={i}>


                                                        <td>{row?.title || "-"}</td>
                                                        <td>{row?.description || "-"}</td>
                                                        <td>{row?.imageUrl || "-"}</td>
                                                        <td>{row?.priority ?? "-"}</td>
                                                        <td>{row?.startDate || "-"}</td>
                                                        <td>{row?.endDate || "-"}</td>
                                                        <td>{row?.isActive == true ? "Yes" : "No"}</td>
                                                        <td>{row?.createdAt || "-"}</td>
                                                        <td>
                                                            {/* <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button> */}
                                                            <button className='btn action-btn' onClick={e => handleDelete(row?.id)}>
                                                                <i className='fa fa-trash-o' />
                                                            </button>
                                                        </td>
                                                        {/* : ""} */}
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <Pagination
                                    count={Math.ceil(totalPage)}
                                    page={currentPage + 1}
                                    onChange={handlePageChange}
                                    color="success" variant="outlined" shape="rounded"
                                    style={{ display: 'flex', justifyContent: 'end' }}
                                />
                            </>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                            </p>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
